import React from 'react';
import { Navbar } from '@codeparva/ui-components-library';
import { NavBarTypes } from './navBarTypes';

export const NavBarLogo = ({
  facility,
  handleNavBarStateForLogo,
}: NavBarTypes.TNavBarLogo) => {
  const { facilityLogo, facilityName } = facility;
  return (
    <Navbar.Item
      href="/"
      onClick={(e: any) => {
        handleNavBarStateForLogo(e);
      }}
      className={`logoContainer ${facilityLogo && facilityLogo.logo === '' ? 'noPadding' : ''
        }`}
    >
      {facilityLogo && facilityLogo?.logo !== '' ? (
        <img
          src={facilityLogo.logo}
          alt={facilityLogo.altText}
          className="logo"
          height={facilityLogo?.height}
          width={facilityLogo?.width}
        ></img>
      ) : (
        <p>{facilityName}</p>
      )}
    </Navbar.Item>
  );
};
